export default __webpack_public_path__ + "static/media/hristina_l.3f710395.jpg";